import {css} from 'lit';

export default css`
:host {
    background-color: var(--cp-grey-light-7);
    position: relative;
    display: block;
    padding: 1.6rem;
}

.panels {
    display: flex;
    flex-direction: column;
    gap: 1.6rem;
}
`;
